// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"c1137c45","502":"dd29adcd","824":"2ee12f00","842":"49dd8e58"}[chunkId] + ".chunk.css";
};